export const ROLES = [{
  name: 'NonprofitManager',
  id: 3,
  display: 'Manager'
}, {
  name: 'NonprofitAdmin',
  id: 1,
  display: 'Administrator'
}];

/**
 * Enum for user roles.
 * (aligns with AspNetRoles table)
 */
export enum Role {
  NonprofitAdmin = 1,
  SiteAdmin = 2,
  NonprofitManager = 3,
  YcAdmin = 4,
  YcSupport = 5,
  YcNonprofitManager = 6,
  ComplianceAdmin = 7,
  ImplementationManager = 8,
  CheckReissue = 9,
  YCNonprofitACHManager = 10,
  YcReporting = 11,
  Engineering = 12
}
